import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LineUpCard from "./line-up-card";

const artists = [
  {
    name: "The Beta Band",
    sort: "Beta Band",
    link: "https://www.thebetaband.com/",
    img: "betaband.jpg",
  },
  {
    name: "Freak Slug",
    sort: "Freak Slug",
    link: "https://open.spotify.com/artist/5wk7sY8GIg5ihSI09EbWeS",
    img: "freakslug.jpg",
  },
  {
    name: "GHOSTWOMAN",
    sort: "GHOSTWOMAN",
    link: "https://ghost-woman.com/",
    img: "ghoistwoman.jpg",
  },
  {
    name: "Floral Image",
    sort: "Floral Image",
    link: "https://floralimageband.com/",
    img: "floral.jpeg",
  },
  {
    name: "Gwenno",
    sort: "Gwenno",
    link: "https://www.gwenno.info/",
    img: "gwenno.jpg",
  },
  {
    name: "LEMONSUCKR",
    sort: "LEMONSUCKR",
    link: "https://open.spotify.com/artist/3GOEpVQKFuVvZeFAyu8a8M",
    img: "lemon.jpg",
  },
  {
    name: "MARTIAL ARTS",
    sort: "MARTIAL ARTS",
    link: "https://open.spotify.com/artist/6Io0X7BBqmDmJLaKbEq14E",
    img: "martialart.jpg",
  },
  {
    name: "MLEKO",
    sort: "MLEKO",
    link: "https://open.spotify.com/artist/2FsA3E38MJNvzKQbQOeb4q",
    img: "mleko.jpg",
  },
  {
    name: "NIGHT TAPES",
    sort: "NIGHT TAPES",
    link: "https://nighttapesmusic.net/",
    img: "nighttapes.jpg",
  },
  {
    name: "Thistle",
    sort: "Thistle",
    link: "https://thistle.band/",
    img: "thistle.jpg",
  },
  {
    name: "WORKING MEN’S CLUB",
    sort: "WORKING MEN’S CLUB",
    link: "https://workingmensclub.net/",
    img: "wmc.jpg",
  },
  {
    name: "ADULT DVD",
    sort: "ADULT DVD",
    link: "https://adultdvd.band/",
    img: "Adult DVD.jpg",
  },
  {
    name: "ALLAH-LAS",
    sort: "ALLAH LAS",
    link: "https://allahlas.com/",
    img: "Allah Las.jpg",
  },
  {
    name: "ANNABELLE CHAIRLEGS",
    sort: "ANNABELLE CHAIRLEGS",
    link: "https://www.annabellechairlegs.com/",
    img: "Annabelle Chairlegs.jpg",
  },
  {
    name: "ANNA VON HAUSSWOLFF",
    sort: "ANNA VON HAUSSWOLFF",
    link: "https://www.annavonhausswolff.com/",
    img: "anna von 1 .png",
  },
  {
    name: "DREAMWAVE",
    sort: "DREAMWAVE",
    link: "https://open.spotify.com/artist/26msUtMobWU9L6LAWXCih3",
    img: "DREAMWAVE.JPG",
  },
  {
    name: "GROUP A.D.",
    sort: "GROUP A.D.",
    link: "https://open.spotify.com/artist/5bz3zjhreG3PrBmyUBy3Z9",
    img: "Group A.D..jpeg",
  },
  {
    name: "HONK",
    sort: "HONK",
    link: "https://open.spotify.com/artist/4uk3lduSwfiRaVUt7HvRqR",
    img: "HONK.jpg",
  },
  {
    name: "THE KVB",
    sort: "KVB",
    link: "https://www.thekvb.co.uk/",
    img: "THE KVB 1.jpg",
  },
  {
    name: "LAEL NEALE",
    sort: "LAEL NEALE",
    link: "https://laelneale.com/",
    img: "LaelNeale_2025_promo_02_SevenRuck_2626x2080_2400.jpg",
  },
  {
    name: "MODEL/ACTRIZ",
    sort: "MODEL/ACTRIZ",
    link: "https://www.modelactriz.com/",
    img: "Model Actriz.jpg",
  },
  {
    name: "POLLYFROMTHEDIRT",
    sort: "POLLYFROMTHEDIRT",
    link: "https://open.spotify.com/artist/3mNIIIyyVyJvCeO3ZpqlpM",
    img: "pollyfromthedirt.jpg",
  },
  {
    name: "ROSCOE ROSCOE",
    sort: "ROSCOE ROSCOE",
    link: "https://open.spotify.com/artist/2S1VbdF38EZGQ2QRdiDVZZ",
    img: "Roscoe Roscoe.jpg",
  },
  {
    name: "RUDE FILMS",
    sort: "RUDE FILMS",
    link: "https://open.spotify.com/artist/35R4qVcXB39p86z98ZCpra",
    img: "RUDE FILMS.jpeg",
  },
  {
    name: "SEX MASK",
    sort: "SEX MASK",
    link: "https://open.spotify.com/artist/58TcB8X9Cr1VpR9PrXJeTQ",
    img: "Sex Mask.jpg",
  },
  {
    name: "S.G. GOODMAN",
    sort: "S.G. GOODMAN",
    link: "https://www.sggoodman.net/",
    img: "S.G. Goodman.jpg",
  },
  {
    name: "SHAKING HAND",
    sort: "SHAKING HAND",
    link: "https://open.spotify.com/artist/3HPGoeMdjOGfyi1GGl0G0J",
    img: "Shaking Hand OTC LEAD - credit_ Sam Lindley.jpg",
  },
  {
    name: "SILVER GORE",
    sort: "SILVER GORE",
    link: "https://open.spotify.com/artist/5VrSyJDlKqvbpRaRBaA4o2",
    img: "Silver Gore 1 .jpg",
  },
  {
    name: "SNUGGLE",
    sort: "SNUGGLE",
    link: "https://open.spotify.com/artist/3hD5jCWM1Kzj6BqhnwICTa",
    img: "Snuggle .jpg",
  },
  {
    name: "STEREOLAB",
    sort: "STEREOLAB",
    link: "https://stereolab.co.uk/",
    img: "Stereolab.jpg",
  },
  {
    name: "TY SEGALL",
    sort: "TY SEGALL",
    link: "https://ty-segall.com/pages/home",
    img: "Ty_Segall.jpg",
  },
  {
    name: "WATER MACHINE",
    sort: "WATER MACHINE",
    link: "https://open.spotify.com/artist/2TqWKblaghM2hhKjmyRtn7",
    img: "WATER MACHINE SQUARE.png",
  },

  {
    name: "Angine de poitrine",
    sort: "Angine de poitrine",
    link: "https://open.spotify.com/artist/13NmOYYfvONNZ9mn2qn8P2?si=1RCaGOBOQhyX3K_OsupIig",
    img: "angine.png",
  },
  {
    name: "Automatic",
    sort: "Automatic",
    link: "https://automatic.band/",
    img: "automatic.jpg",
  },
  {
    name: "The Belair Lip Bombs",
    sort: "Belair Lip Bombs",
    link: "https://thebelairlipbombs.com/",
    img: "belair.jpg",
  },
  {
    name: "White Denim",
    sort: "White Denim",
    link: "https://whitedenimmusic.com/",
    img: "white.jpg",
  },

  {
    name: "Alex Amen",
    sort: "Alex Amen",
    link: "https://alexamen.com/",
    img: "ALEX AMEN .jpeg",
  },
  {
    name: "Bathing Suits",
    sort: "Bathing Suits",
    link: "https://open.spotify.com/artist/0wAHOA5JY06O6TbyGLn9zR?si=x1S2uAR4TNqphs7XeaQ2Ww",
    img: "BATHING SUITS.jpg",
  },
  {
    name: "BDRMM",
    sort: "BDRMM",
    link: "https://open.spotify.com/artist/4Cx5LnF4WNJIn9SSqyeq9C?si=tlVF76JrQbizT7YLPMLYbw",
    img: "bdrmm2026.jpg",
  },
  {
    name: "Billy Nomates",
    sort: "Billy Nomates",
    link: "https://open.spotify.com/artist/0QJaBD8Piha8IEwKtNpBOB?si=HxkWNOIcQcWdNPvP2Ayg7g",
    img: "BILLY NOMATES 1.jpg",
  },
  {
    name: "Bleech 9:3",
    sort: "Bleech 9:3",
    link: "https://bleech93.os.fan/",
    img: "bleech 93.jpg",
  },
  {
    name: "The Dharma Chain",
    sort: "Dharma Chain",
    link: "https://www.thedharmachain.com/",
    img: "The Dharma Chain.jpg",
  },
  {
    name: "GANS",
    sort: "GANS",
    link: "https://gansnet.os.fan/",
    img: "GANS .png",
  },
  {
    name: "Girl Group",
    sort: "Girl Group",
    link: "https://www.thisisgirlgroup.com/",
    img: "Girl Group.jpg",
  },
  {
    name: "The Healing Power of Horses",
    sort: "Healing Power of Horses",
    link: "https://open.spotify.com/artist/4ps9FIxIQatbBhudrWSK3J?si=WdyTTbgvS5G25bwu0B0lnA",
    img: "The Healing Power of Horses.jpg",
  },
  {
    name: "The Heavenly Bodes",
    sort: "Heavenly Bodes",
    link: "https://open.spotify.com/artist/3bvrrRepHGlIE8jV8bk7B5?si=z0wk_cDSS9-VgP0zw_27Fg",
    img: "bodes.jpg",
  },
  {
    name: "Holy Wave",
    sort: "Holy Wave",
    link: "https://open.spotify.com/artist/0Cx9SrMKbfrkHvnqJLHq6b?si=7KfKkkPeRlWe5SZwmAT7yg",
    img: "HOLY WAVE.JPG",
  },
  {
    name: "Iona Gray",
    sort: "Iona Gray",
    link: "https://open.spotify.com/artist/17jgdxHigUF5gBFgAATnDp?si=GkZkY9B7STuv-YbpejAjEA",
    img: "IONA GRAY.jpg",
  },
  {
    name: "Ishango Bone",
    sort: "Ishango Bone",
    link: "https://open.spotify.com/artist/4ZcMrpikW9Snx2G92ObvHS?si=w6m2rOzSTJ207jQN1XRvDQ",
    img: "Ishango Bone.jpeg",
  },
  {
    name: "Just Like Honey",
    sort: "Just Like Honey",
    link: "https://open.spotify.com/artist/24GRf08pta48m1hijAFrPF?si=LAqzSTYNRIiHsr5o0Lm2rA",
    img: "Just Like Honey.jpeg",
  },
  {
    name: "Kombynat Robotron",
    sort: "Kombynat Robotron",
    link: "https://open.spotify.com/artist/6CXEydJY5ufl8vyebmNnxW?si=OP-uNdrjSam1pgQnxVPARQ",
    img: "KombynatRobotron_2025.jpg",
  },
  {
    name: "Konformer",
    sort: "Konformer",
    link: "https://open.spotify.com/artist/73jkWMagZsPQFG6qcXfoPV?si=5IH8cBaPTwSQ8LUJ7H9o2g",
    img: "Konformer_Maxi_01_25_1.jpg",
  },
  {
    name: "Lily Rae Grant",
    sort: "Lily Rae Grant",
    link: "https://open.spotify.com/artist/0pg4XXNI4UewO0pEpaP16g?si=nOc9tv1QRIasUBFDllboBw",
    img: "Lily Rae Grant.jpg",
  },
  {
    name: "LTTL MORT",
    sort: "LTTL MORT",
    link: "https://www.instagram.com/lttlmort/",
    img: "lttl mort 2.jpeg",
  },
  {
    name: "Lowertown",
    sort: "Lowertown",
    link: "https://www.lowertown.band/",
    img: "Lowertown.jpg",
  },
  {
    name: "Mandy, Indiana",
    sort: "Mandy, Indiana",
    link: "https://open.spotify.com/artist/2nDJxXJ7PtW7eLpFXcGH3u?si=pAPRxe2oT4G3uC56MUgxVg",
    img: "MANDY, INDIANA.jpg",
  },
  {
    name: "Maquina.",
    sort: "Maquina.",
    link: "https://open.spotify.com/artist/0U1D3GEq0HYA82J6WWw3DT?si=XfeWJWHLRL-sYeuq_DgQ2w",
    img: "Maquina.jpg",
  },
  {
    name: "Morn",
    sort: "Morn",
    link: "https://open.spotify.com/artist/0kyIsGsq7em6p0dOUwOAI3?si=LPB1_WHoSVOFfSk_p3zZQg",
    img: "MORN 1.jpeg",
  },
  {
    name: "Nightbus",
    sort: "Nightbus",
    link: "https://open.spotify.com/artist/1fbC8ATYVPUeFy2h5NOK8x?si=jxLRYXKXTuGL3_Sbvr2oug",
    img: "Nightbus.jpg",
  },
  {
    name: "Prewn",
    sort: "Prewn",
    link: "https://open.spotify.com/artist/1Sm5PqM25CcIBtKSvZz9iS?si=eewpe_KbTa-KFYAbshV58Q",
    img: "Prewn.jpg",
  },
  {
    name: "Renny Conti",
    sort: "Renny Conti",
    link: "https://www.rennyconti.com/",
    img: "Renny Conti.jpeg",
  },
  {
    name: "Slowhandclap",
    sort: "Slowhandclap",
    link: "https://open.spotify.com/artist/1oHRlVvzhRtgFOsjfLMTrD?si=pIWaY6SuRe6MhwP-euKyRA",
    img: "Slowhandclap.jpeg",
  },
  {
    name: "The Speed of Honey and Her Oscillations",
    sort: "Speed of Honey and Her Oscillations",
    link: "https://www.instagram.com/thespeedofhoney/",
    img: "speedhoney.jpg",
  },
  {
    name: "Spiral Drive",
    sort: "Spiral Drive",
    link: "https://www.spiraldrivemusic.com/",
    img: "Spiral Drive.jpg",
  },
  {
    name: "Tanzana",
    sort: "Tanzana",
    link: "https://open.spotify.com/artist/2mwOkIqXhMvuo4NIOf2vqQ?si=xtoQhz2sSuuQLmqdy0Sxpw",
    img: "Tanzana 1.jpeg",
  },
  {
    name: "Tesni",
    sort: "Tesni",
    link: "https://tesni.bandcamp.com/",
    img: "TESNI.jpg",
  },
  {
    name: "Turnspit",
    sort: "Turnspit",
    link: "https://open.spotify.com/artist/1HbKJU6NYDySoBXuAi5dNB?si=RKG9yZGwQeeMiKGOVT1c_w",
    img: "turn.jpg",
  },

  {
    name: "Drook",
    sort: "Drook",
    link: "https://open.spotify.com/artist/2WeD1vAUXMF0QB3zQBcVq9?si=YOlmENvrT3WIQyzp7IyE6w",
    img: "Drook.jpg",
  },
  {
    name: "Mogan",
    sort: "Mogan",
    link: "https://open.spotify.com/artist/3JeXOiITaBsq0nEvvwf3g1?si=Y1j2FkVzROi63up6UjFrmw",
    img: "mogan.jpg",
  },
];

const sortedArtists = artists.sort((a, b) => a.sort.localeCompare(b.sort));

function LineUp() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <Box sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}>
        {sortedArtists.map((artist) => (
          <LineUpCard key={artist.name} artist={artist} />
        ))}
      </Box>
    </Container>
  );
}
export default LineUp;
